export default __webpack_public_path__ + "static/media/check_box_black_24dp.bdf36f78.svg";